/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR, AJRS } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function getNotificationGroupActiveEntries(firebase_email, firebase_token, ngp_uid_list, org_uid_list, sys_uid=null, obj_uid=null, obj_atr_uid=null) {
  return new Promise(function (resolve, reject) {
    var return_msg = "";
    var debug_data = [];
    var call_result = {};
    var task_id = "p2s7t16getNotificationGroupActiveEntries";
    var active_entries = {};

    ///// input validation
    call_result = bi1_data_validation.is_email_address(firebase_email);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(ngp_uid_list);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(org_uid_list);
    debug_data.push(call_result);

    if (sys_uid !== null) {
      call_result = bi1_data_validation.is_system_uid(sys_uid);
      debug_data.push(call_result);
    }
    if (obj_uid !== null) {
      call_result = bi1_data_validation.is_object_uid(obj_uid);
      debug_data.push(call_result);
    }
    if (obj_atr_uid !== null) {
      call_result = bi1_data_validation.is_object_attribute_uid(obj_atr_uid);
      debug_data.push(call_result);
    }

    var validation_failed_flag = false;
    for (var index in debug_data) {
      if (debug_data[index][CR.success] != RC.success) {
        validation_failed_flag = true;
        break;
      }
    }

    if (validation_failed_flag == true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data, group_history: group_history });
    }
    /////</end> input validation

    var params = {
      'p2s7_firebase_email': firebase_email,
      'p2s7_token': firebase_token,
      'p2s7t16_ngp_uid_list': JSON.stringify(ngp_uid_list),
      'p2s7t16_org_uid_list': JSON.stringify(org_uid_list),
      'p2s7t16_sys_uid': sys_uid ? sys_uid.replace("sys_", "") : null,
      'p2s7t16_obj_uid': obj_uid ? obj_uid.replace("obj_", "") : null,
      'p2s7t16_obj_atr_uid': obj_atr_uid ? obj_atr_uid.split("-")[1] : null
    }

    ajax({
      url: window.G_ajax_test_domain + '/json-requests/p2s7t16-get-notification-group-active-entries',
      method: 'POST',
      data: params,
      success: function (result) {
        active_entries = result;
        resolve({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, active_entries: active_entries});
      },
      error: function (err) {
        if (err.status == 401) {
          window.G_firebase_auth.bi5forceTokenRefresh();
        }
        return_msg += "Failed to get notification group active entries, error data:" + JSON.stringify(err);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
        reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, active_entries: active_entries});
      }
    })

  });
};

export default getNotificationGroupActiveEntries 



// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p2s7/p2s7t16.js